import { IRootState } from "../../../redux/root.reducer";

export const ITEMS_PER_PAGE_ALL = -1;
const MAX_ITEMS_LIMIT = 10000;

export const selectListBuilderFiltersAndPagination = (state: IRootState) => {
    const limit =
        state.listBuilderTable.listBuilderTable.pagination.itemsPerPage;
    return {
        email: state.listBuilderTable.listBuilderTable.currentUser?.email,
        query: state.listBuilderTable.listBuilderTable.searchQuery,
        limit: limit === ITEMS_PER_PAGE_ALL ? MAX_ITEMS_LIMIT : limit,
        offset:
            limit === ITEMS_PER_PAGE_ALL
                ? 0
                : (state.listBuilderTable.listBuilderTable.pagination
                      .currentPage -
                      1) *
                  limit,
        sortField: state.listBuilderTable.listBuilderTable.sorting.column,
        sortDirection: state.listBuilderTable.listBuilderTable.sorting.order,
    };
};
